import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../utils';
import { useModal } from './context';
export function ModalViews() {
    const { stack, initialView } = useModal();
    const root = stack[stack.length - 1] ?? initialView;
    const top = stack.length > 1 ? stack[0] : null;
    return (_jsxs("div", { className: "relative overflow-hidden w-full min-h-0 flex flex-col bg-surface", children: [_jsx("div", { className: cn('flex flex-col min-h-0 w-full bg-surface', 'transition-transform duration-150 ease-[cubic-bezier(0.32,0.72,0,1)] motion-reduce:transition-none', {
                    'translate-x-0': !top,
                    '-translate-x-[30%] pointer-events-none': top,
                }), "aria-hidden": Boolean(top), children: root.component }), top && (_jsx("div", { className: cn('absolute inset-0 flex flex-col min-h-0 w-full bg-surface', 'transition-transform duration-150 ease-[cubic-bezier(0.32,0.72,0,1)] motion-reduce:transition-none', 'translate-x-0 starting:transform-[translateX(100%)]'), children: top.component }, top.id))] }));
}
